/*
 * Created by Joseph Saliba on 11/15/16.
 */

export class ListItem {
  private id: string;
  private name: string;

  constructor(id: string, name: string) {
    this.id = id;
    this.name = name;
  }
}
